// Google Contacts CSV, for importing a league or tournament's players into
// Google Contacts and from there into WhatsApp.
//
// The header is Google's own, column for column, taken from an export Steve
// made (contacts.csv in the Leagues folder). Google matches on these exact
// names, so the empty columns are kept rather than trimmed — a shorter header
// imports as unmapped fields.
//
// Two columns carry what the club knows and Google has no field for:
//   Notes             -> the league or tournament name
//   Organization Name -> the team
const HEADER = [
  'First Name', 'Middle Name', 'Last Name',
  'Phonetic First Name', 'Phonetic Middle Name', 'Phonetic Last Name',
  'Name Prefix', 'Name Suffix', 'Nickname', 'File As',
  'Organization Name', 'Organization Title', 'Organization Department',
  'Birthday', 'Notes', 'Photo', 'Labels',
  'E-mail 1 - Label', 'E-mail 1 - Value',
  'Phone 1 - Label', 'Phone 1 - Value',
];

// What Google writes in its own exports: the group every contact belongs to,
// and a bare '* ' for an email with no specific label. Copied so an import
// lands the same way a Google export would.
const MY_CONTACTS = '* myContacts';
const DEFAULT_EMAIL_LABEL = '* ';

const cell = (v) => {
  const t = v == null ? '' : String(v);
  return /[",\r\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t;
};

// +1 407-923-7312, matching the sample. A number Google cannot parse is still
// better in the file than dropped, so anything unexpected goes through as typed.
export function contactPhone(raw) {
  const d = String(raw || '').replace(/\D/g, '');
  if (d.length === 10) return `+1 ${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d.startsWith('1')) {
    return `+1 ${d.slice(1, 4)}-${d.slice(4, 7)}-${d.slice(7)}`;
  }
  return String(raw || '').trim();
}

/**
 * One CSV row per contact. { firstName, lastName, email, phone, notes,
 * organization } — notes is the event, organization the team.
 */
function contactRow({ firstName, lastName, email, phone, notes, organization }) {
  const row = new Array(HEADER.length).fill('');
  row[0] = String(firstName || '').trim();
  row[2] = String(lastName || '').trim();
  row[10] = String(organization || '').trim();
  row[14] = String(notes || '').trim();
  row[16] = MY_CONTACTS;
  if (email) { row[17] = DEFAULT_EMAIL_LABEL; row[18] = String(email).trim(); }
  if (phone) { row[19] = 'Mobile'; row[20] = contactPhone(phone); }
  return row.map(cell).join(',');
}

/**
 * The whole file. Contacts with neither an email nor a phone are dropped —
 * a name alone is not a contact and imports as an empty card — and duplicates
 * are collapsed on phone then email, since a family shares both.
 */
export function googleContactsCsv(contacts) {
  const seen = new Set();
  const rows = [];
  for (const c of contacts || []) {
    const phoneKey = String(c.phone || '').replace(/\D/g, '');
    const key = phoneKey || String(c.email || '').trim().toLowerCase();
    if (!key) continue;
    if (seen.has(key)) continue;
    seen.add(key);
    rows.push(contactRow(c));
  }
  return [HEADER.join(','), ...rows].join('\r\n');
}
